import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, List, ListItem, Paper, Typography } from '@mui/material';

import usePostQuery from '../../../Hooks/usePostQuery';
import PostListItem from '../../DesignSystem/PostListItem';

function OriginalPost({ post, space }: any) {
  const { post: originalPost } = usePostQuery(post.original_post_id, {
    enabled: !!post.original_post_id,
  });

  if (!originalPost) {
    return null;
  }

  return (
    <Box sx={{ mt: 6 }}>
      <Typography variant="h6" component="h3">
        <strong>
          <FormattedMessage id="ORIGINAL_POST.TITLE" />
        </strong>
      </Typography>

      <Paper component={Box} my={3}>
        <List disablePadding>
          <ListItem disableGutters>
            <PostListItem post={originalPost} space={space} hideButtons />
          </ListItem>
        </List>
      </Paper>
    </Box>
  );
}

export default OriginalPost;
